<template>
  <div class="card purple">
    <div class="content">
      <div class="header">
        {{ $t('FILESYSTEM') }}
        <i class="right floated open folder icon"></i>
      </div>
      <div
        class="meta"
        v-html="
          $t('FILESYSTEM_META', {
            directory: trigger.configuration.directory,
            match: trigger.configuration.match
          })
        "
      ></div>
    </div>

    <div class="primary content">
      <div class="ui tiny negative message" v-if="errorMessage">
        <i class="bullhorn icon"></i>
        {{ errorMessage }}
      </div>

      <div class="field">
        <label for="directory">{{ $t('FILESYSTEM_DIRECTORY') }}</label>
        <input
          id="directory"
          type="text"
          :placeholder="$t('FILESYSTEM_DIRECTORY_PLACEHOLDER')"
          v-model="trigger.configuration.directory"
        />
      </div>

      <regex-field
        v-model="trigger.configuration.match"
        :labelText="$t('FILESYSTEM_MATCH')"
        :placeholder="$t('FILESYSTEM_MATCH_PLACEHOLDER')"
      />
    </div>

    <slot name="footer"></slot>
  </div>
</template>

<script>
// @flow
import Vue from 'vue'
import _ from 'lodash'
import { Hotkey, Flow } from 'services'
import { map } from 'rxjs/operators'
import { RegexField } from 'ui'

export default {
  name: 'filesystemtrigger',
  components: { RegexField },
  props: {
    trigger: {
      type: Object,
      default: () => {
        return {
          configuration: {
            match: '',
            directory: ''
          }
        }
      }
    }
  },

  data() {
    return {
      errorMessage: null
    }
  }
}
</script>
